<template>
<div>
  <div class="container-fluid">
    <div class="row groucerySlider">
      <div class="col-12 p-0">
        <slick ref="slickfive" :options="slickOptions">
          <div class="gSliders">
            <img src="img/groceryBanner1.jpg" class="img-fluid" alt="" />
          </div>
          <div class="gSliders">
            <img src="img/groceryBanner1.jpg" class="img-fluid" alt="" />
          </div>
          <div class="gSliders">
            <img src="img/groceryBanner1.jpg" class="img-fluid" alt="" />
          </div>
          <div class="gSliders">
            <img src="img/groceryBanner1.jpg" class="img-fluid" alt="" />
          </div>
        </slick>
      </div>
    </div>
    <div class="row">
      <div class="col-12 p-0">
        <div class="browserStore">
          <router-link
            :to="{
              name: 'list',
              query: { store: this.$route.query.store , isFromStore: true },
              params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
             
            }
            "
          >
            Browse Store
          </router-link>
        </div>
      </div>
    </div>
    <div class="row my-5">
      <div class="col-md-4">
        <img src="img/diwaliDhamaka.jpg" class="img-fluid" alt="" />
      </div>
      <div class="col-md-8">
        <img src="img/fastivalSale.jpg" class="img-fluid" alt="" />
        <div class="row">
          <div class="col-md-6 mt-4">
            <img src="img/saveBig.jpg" class="img-fluid" alt="" />
          </div>
          <div class="col-md-6 mt-4">
            <img src="img/off70.jpg" class="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h2 class="gHeading">HOME ESSENTIALS</h2>
      </div>
      <div class="col-11 gProduct m-auto mb-4">
        <slick ref="slick" :options="slickOptions1">
          <div class="gProductSlider">
            <div class="gProductImg">
              <img src="img/dryFruits.png" class="img-fluid" alt="" />
              <div class="gDiscount">33% OFF</div>
            </div>
            <div class="gProductDetail">
                <p class="gProductName">Dry Fruits Buy 1 Get 1 Free</p>
                <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                <p class="gProductUnit">2 units (400-500g)</p>                
            </div>
            <div class="gProductAdd">
              <button>ADD <span>&#43;</span></button>
            </div>
          </div>
          <div class="gProductSlider">
            <div class="gProductImg">
              <img src="img/freshner.jpg" class="img-fluid" alt="" />
              <div class="gDiscount">33% OFF</div>
            </div>
            <div class="gProductDetail">
                <p class="gProductName">Mouth Freshnes maha pack</p>
                <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                <p class="gProductUnit">500g</p>                
            </div>
            <div class="gProductAdd">
              <button>ADD <span>&#43;</span></button>
            </div>
          </div>
          <div class="gProductSlider">
            <div class="gProductImg">
              <img src="img/dryFruits.png" class="img-fluid" alt="" />
              <div class="gDiscount">33% OFF</div>
            </div>
            <div class="gProductDetail">
                <p class="gProductName">Dry Fruits Buy 1 Get 1 Free</p>
                <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                <p class="gProductUnit">2 units (400-500g)</p>                
            </div>
            <div class="gProductAdd">
              <button>ADD <span>&#43;</span></button>
            </div>
          </div>
          <div class="gProductSlider">
            <div class="gProductImg">
              <img src="img/freshner.jpg" class="img-fluid" alt="" />
              <div class="gDiscount">33% OFF</div>
            </div>
            <div class="gProductDetail">
                <p class="gProductName">Mouth Freshnes maha pack</p>
                <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                <p class="gProductUnit">500g</p>                
            </div>
            <div class="gProductAdd">
              <button>ADD <span>&#43;</span></button>
            </div>
          </div>

        </slick>
      </div>
    </div>
    
  </div>
  <div class="container-fluid shopForBg">
      <div class="row">
        <div class="col-12">
            <h2 class="gHeading">Shop For</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="shopProduct">
              <img src="img/shop1.jpg" class="img-fluid" alt="">
              <p>Grocery & Staples</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="shopProduct">
              <img src="img/shop2.jpg" class="img-fluid" alt="">
              <p>Vegetables & Fruits</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="shopProduct">
              <img src="img/shop3.jpg" class="img-fluid" alt="">
              <p>Household Items</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="shopProduct">
              <img src="img/shop4.jpg" class="img-fluid" alt="">
              <p>Personal Care</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row py-4">
        <div class="col-12">
          <h2 class="gHeading">MOST SELLING PRODUCTS</h2>
        </div>
        <div class="col-11 gProduct m-auto">
          <slick ref="slick" :options="slickOptions1">
            <div class="gProductSlider">
              <div class="gProductImg">
                <img src="img/dryFruits.png" class="img-fluid" alt="" />
                <div class="gDiscount">33% OFF</div>
              </div>
              <div class="gProductDetail">
                  <p class="gProductName">Dry Fruits Buy 1 Get 1 Free</p>
                  <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                  <p class="gProductUnit">2 units (400-500g)</p>                
              </div>
              <div class="gProductAdd">
                <button>ADD <span>&#43;</span></button>
              </div>
            </div>
            <div class="gProductSlider">
              <div class="gProductImg">
                <img src="img/freshner.jpg" class="img-fluid" alt="" />
                <div class="gDiscount">33% OFF</div>
              </div>
              <div class="gProductDetail">
                  <p class="gProductName">Mouth Freshnes maha pack</p>
                  <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                  <p class="gProductUnit">500g</p>                
              </div>
              <div class="gProductAdd">
                <button>ADD <span>&#43;</span></button>
              </div>
            </div>
            <div class="gProductSlider">
              <div class="gProductImg">
                <img src="img/dryFruits.png" class="img-fluid" alt="" />
                <div class="gDiscount">33% OFF</div>
              </div>
              <div class="gProductDetail">
                  <p class="gProductName">Dry Fruits Buy 1 Get 1 Free</p>
                  <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                  <p class="gProductUnit">2 units (400-500g)</p>                
              </div>
              <div class="gProductAdd">
                <button>ADD <span>&#43;</span></button>
              </div>
            </div>
            <div class="gProductSlider">
              <div class="gProductImg">
                <img src="img/freshner.jpg" class="img-fluid" alt="" />
                <div class="gDiscount">33% OFF</div>
              </div>
              <div class="gProductDetail">
                  <p class="gProductName">Mouth Freshnes maha pack</p>
                  <p class="gProductPrice">Rs. 2,460 <del>Rs. 9999</del> </p>
                  <p class="gProductUnit">500g</p>                
              </div>
              <div class="gProductAdd">
                <button>ADD <span>&#43;</span></button>
              </div>
            </div>

          </slick>
        </div>
      </div>
    </div>
    </div>
</template>
<style >
@import "../../node_modules/slick-carousel/slick/slick.css";

:root {
  --main-color: #f00;
}
.logo-color {
  color: var(--main-color) !important;
}
.logo-background-color {
  background-color: var(--main-color) !important;
}
.shopForBg{
  background: linear-gradient(90deg, rgba(251, 237, 150, 0.3) 0%, rgba(171, 236, 214, 0.3) 100%);
      padding-top: 20px;
    padding-bottom: 80px;
    display: inline-block;
}
.shopProduct img{
  width: 100%;
}
.shopProduct{
  position: relative;
  background-color: #fff;
}
.shopProduct p{
    background-color: var(--main-color);
    width: calc(100% - 10%); 
    color: #fff;
    text-align: center;
    font-family: 'lhmRegular';
    font-size: 16px;
    padding: 4px;
    position: absolute;
    bottom: -30px;
    left: 5%;
}
.gHeading{
  text-align: center;
  letter-spacing: 2px;
  color: #626262;
  padding: 15px 0;
  text-transform: uppercase;
}
 

.gProduct .gProductName{
    font-family: 'lhmRegular';
    font-size: 14px;
    padding-top: 10px;
    margin: 0;
}
.gProduct .gProductPrice{
    font-family: 'lhmBold';
    margin-bottom: 0px;
}
.gProduct .gProductPrice del{
    font-family: 'lhmRegular';
}
.gProduct .gProductUnit{
  font-size: var(--font-size-regular);
  margin-bottom: 0;
}
.gProduct .gProductAdd button{
    background-color: var(--main-color);
    color: #fff;
    text-align: center;
    padding: 6px;
    font-family: 'lhmBold';
    /* border-radius: 5px; */
    margin: 8px 0;
    border: none;
    width: 100%;
    position: relative;
    cursor: pointer;
}
.gProduct .gProductAdd button span{
    position: absolute;
    right: 0;
    padding: 3px 10px;
    background-color: rgba(0,0,0,.1123);
    top: 0;
    font-weight: 100;
    font-size: 20px;
}
.gProduct .slick-slide{
  padding: 0 20px;
}
.gProductSlider .gProductImg{
    border: 1px solid #F5F5F4;
    position: relative;
    margin: auto;
    display: flex;
    height: 236px;
    justify-content: center;
    align-items: center;
}
.gProductSlider{
  width: 100%;
}
.gDiscount{
  position: absolute;
  left: 0;
  top:20px;
  background-color: #51AA1B;
  color: #fff;
  font-size: 12px;
  padding: 2px 10px;
}
.groucerySlider .slick-next {
  right: 41px;
  background-color: #fff;
  width: auto;
  height: auto;
}
.groucerySlider .slick-arrow:hover:before {
  color: var(--main-color);
}
.groucerySlider .slick-prev {
  left: 41px;
  background-color: #fff;
  width: auto;
  height: auto;
}
.groucerySlider .slick-prev:before {
  content: "\f053" !important;
  font: normal normal normal 14px/1 FontAwesome;
  color: #a2a2a2;
  font-size: 15px;
  padding: 11px 14px;
  display: inline-block;
}
.groucerySlider .slick-next:before {
  content: "\f054" !important;
  font: normal normal normal 14px/1 FontAwesome;
  color: #a2a2a2;
  font-size: 16px;
  padding: 14px 16px;
  display: inline-block;
}
</style>
<script>
import slick from "vue-slick";

export default {
  name: "banner",
  components: { slick },
  mounted() {
    this.get_banner();
  },
  methods: {
    get_banner() {
      axios
        .get(
          this.$root.api_url +
            `/pim/pimresponse.php?service=banner_slider&store=${this.$root.store}`
        )
        .then((response) => {
          this.slider = response.data.result;
          this.slider_show = true;
        });
    },
  },
  data() {
    return {
      slider: "",
      slider_show: false,
      slickOptions: {
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        pauseOnFocus: false,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              dots: false,
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },

      slickOptions1: {
                    slidesToShow: 4,
                    infinite: false,
                    dot:true,
                    swipeToSlide:true,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                // centerMode: true,
                                // centerPadding: '65px'
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                arrows: false,
                                slidesToShow: 2.5,
                                slidesToScroll: 2.5,
                                // centerMode: true,
                                // centerPadding: '0px'
                            }
                        }

                    ]
                    // Any other options that can be got from plugin documentation
                },
    };
  },
};
</script>